import { CreateTemplateTypes } from './types'

/**
 * CreateTemplate function docs
 * @param {object} data - An object that define properties for a new template
 */
export function CreateTemplate(data: CreateTemplateTypes): Object {
  return data
}
